import { Mail, Phone, Globe, MapPin, Linkedin } from "lucide-react";
import { imageBaseUrl } from "../../utils/utils";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import fetcher from "../../helper/fetcher";
import { CircularProgress } from "@mui/material";

export default function ProfileCard() {
    const { userId } = useParams()
    // const id = "68d03ec50a50d9e722174827";
    const [userData, setUserData] = useState({});
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (userId) {
            setIsLoading(true)
            fetcher.get(`/qr/auth/get_userById/${userId}`)
                .then((res) => {
                    // console.log("qr page ===>>", res.data)
                    setUserData(res?.data?.data)
                })
                .catch((error) => {
                    // console.log("qr error ==>>", error)
                }).finally(() => {
                    setIsLoading(false)
                })
        }
    }, [])

    //     const generateVCard = (userData) => {
    //         return `
    // BEGIN:VCARD
    // VERSION:3.0
    // FN:${userData?.name || ""}
    // TITLE:${userData?.title || ""}
    // ORG:${userData?.company || ""}
    // TEL;TYPE=work,voice:${userData?.telephone || ""}
    // EMAIL;TYPE=work:${userData?.email || ""}
    // URL:${userData?.website || ""}
    // ADR;TYPE=work:;;${userData?.address || ""}
    // END:VCARD
    //   `.trim();
    //     };


    const generateVCard = (userData) => {
        return `
BEGIN:VCARD
VERSION:3.0
FN:${userData?.name || ""}
N:${userData?.name || ""};;;;
TITLE:${userData?.title || ""}
ORG:${userData?.company || ""}
TEL;TYPE=work,voice:${userData?.telephone || ""}
EMAIL;TYPE=work:${userData?.email || ""}
URL:${userData?.website || ""}
X-SOCIALPROFILE;type=linkedin:${userData?.linkedin || ""}
ADR;TYPE=work:;;${userData?.address || ""}
END:VCARD
  `.trim();
    };


    const handleSaveContact = () => {
        const vcard = generateVCard(userData);

        const blob = new Blob([vcard], { type: "text/vcard" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `${userData?.name || "contact"}.vcf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
    };


    return (
        <>
            {isLoading ?
                <div className="flex items-center justify-center min-h-screen">
                    <CircularProgress size={60} />
                </div> :
                <div className="flex items-center justify-center min-h-screen bg-white p-6 mt-12">
                    <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm">
                        {/* Header */}
                        <div className="bg-gradient-to-br from-[#bf98ce] to-[#8f77c6] p-6 text-center rounded-t-2xl">
                            <img
                                src={
                                    userData?.profile_image?.startsWith("https")
                                        ? userData?.profile_image
                                        : imageBaseUrl + "images/" + `${userData?.profile_image}`
                                }
                                alt={userData?.name}
                                className="md:w-32 md:h-32 w-28 h-28 rounded-full mx-auto border-4 border-white -mt-16 object-cover shadow-md"
                            />
                            <h2 className="text-2xl font-bold text-white mt-4">{userData?.name}</h2>
                            <p className="text-sm text-white opacity-90">{userData?.title}</p>
                        </div>

                        {/* user Details */}
                        <div className="p-6 space-y-4 text-gray-800 overflow-hidden">

                            <div>
                                <div className="font-semibold text-[#7f6bc6] text-[14px] flex items-center gap-2">
                                    Company:
                                </div>
                                <p className="text-gray-700 md:text-[17px] text-[15px]">
                                    {userData?.company}
                                </p>
                            </div>
                            <hr />

                            <div>
                                <div className="font-semibold text-[#7f6bc6] text-[14px] flex items-center gap-2">
                                    <Phone className="w-4 h-4" /> Phone:
                                </div>
                                <a
                                    href={`tel:${userData?.telephone}`}
                                    className="text-gray-700 hover:underline md:text-[17px]  text-[15px]"
                                >
                                    {userData?.telephone}
                                </a>
                            </div>
                            <hr />

                            <div>
                                <div className="font-semibold text-[#7f6bc6] text-[14px] flex items-center gap-2">
                                    <Mail className="w-4 h-4" /> Email:
                                </div>
                                <a
                                    href={`mailto:${userData?.email}`}
                                    className="text-gray-700 hover:underline md:text-[17px]  text-[15px]"
                                >
                                    {userData?.email}
                                </a>
                            </div>
                            <hr />

                            <div>
                                <div className="font-semibold text-[#7f6bc6] text-[14px] flex items-center gap-2">
                                    <Linkedin className="w-4 h-4" /> LinkedIn:
                                </div>
                                <a
                                    href={userData?.linkedin}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-700 hover:underline md:text-[17px]  text-[15px]"
                                >
                                    {userData?.linkedin}
                                </a>
                            </div>
                            <hr />

                            <div>
                                <div className="font-semibold text-[#7f6bc6] text-[14px] flex items-center gap-2">
                                    <Globe className="w-4 h-4" /> Website:
                                </div>
                                <a
                                    href={userData?.website}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-700 hover:underline md:text-[17px]  text-[15px]"
                                >
                                    {userData?.website}
                                </a>
                            </div>
                            <hr />

                            <div>
                                <div className="font-semibold text-[#7f6bc6] text-[14px] flex items-center gap-2">
                                    <MapPin className="w-4 h-4" /> Address:
                                </div>
                                <p className="text-gray-700 md:text-[17px]  text-[15px]">{userData?.address}</p>
                            </div>
                        </div>

                        {/* Button */}
                        <div className="p-3">
                            <button className="w-full flex items-center justify-center gap-2 md:py-3 py-2 bg-[#7f6bc6] hover:bg-[#bf98ce] text-white rounded-xl font-bold transition shadow-md" onClick={handleSaveContact}
                            >
                                Save Contact
                            </button>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}
